import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const FuelTypes = (props: Props) => (
  <FilterAutocomplete
    label="Fuel Types"
    fieldName={'fuelTypes'}
    fieldPath={'productInformation.fuelTypes'}
  />
)
